import { axiosInstance, publicAxiosInstance } from "./Https";
export const apiUrl = process.env.REACT_APP_API_URL;

export const apiGetOne = async (url) => {
  const resp = await axiosInstance.get(url);
  return apiGetData(resp);
};

export const apiGetMany = async (url) => {
  const resp = await axiosInstance.get(url);
  return apiGetData(resp);
};
export const apiGetDocument = async (url) => {
  return axiosInstance.get(url, { responseType: "arraybuffer" });
};

export const apiPatch = async (url, data) => {
  const resp = await axiosInstance.patch(url, data);
  return apiGetData(resp);
};
export const apiPost = async (url, data) => {
  const resp = await axiosInstance.post(url, data);
  return apiGetData(resp);
};

export const apiDelete = async (url) => {
  const resp = await axiosInstance.delete(url);
  return resp && resp.success;
};

function apiGetData(resp) {
  return resp && resp.data ? resp.data : null;
}

export const apiPublicGetOne = async (url) => {
  const resp = await publicAxiosInstance.get(url);
  return apiGetData(resp);
};

export const apiPublicGetMany = async (url) => {
  const resp = await publicAxiosInstance.get(url);
  return apiGetData(resp);
};

export const apiPublicPatch = async (url, data) => {
  const resp = await publicAxiosInstance.patch(url, data);
  return apiGetData(resp);
};
export const apiPublicPost = async (url, data) => {
  const resp = await publicAxiosInstance.post(url, data);
  return apiGetData(resp);
};
